import { useQuery } from '@tanstack/react-query';

import { CustomBulletinBoard } from '@autopass-web/types';

import { SUCCESS_PAGE_BOARD_CODE } from '../config';
import client from './client';

import type { UseQueryOptions } from '@tanstack/react-query';

type SuccessBoard = {
  sub_title?: string;
  image_url?: string;
  background_color?: string;
  parkinglot_ids?: string;
  title?: string;
};

type SuccessBulletinBoard = CustomBulletinBoard<SuccessBoard>;

type SuccessBoardsResponse = {
  [SUCCESS_PAGE_BOARD_CODE]: SuccessBulletinBoard[];
};

const queryFn = () =>
  client.fetchBulletinBoards<SuccessBoardsResponse>({
    codes: SUCCESS_PAGE_BOARD_CODE,
  });

type Response = Awaited<ReturnType<typeof queryFn>>;

const selectSuccessBoards = (response: Response) => {
  return response.data?.data?.[SUCCESS_PAGE_BOARD_CODE] ?? [];
};

export const useSuccessPageBulletinBoards = (
  options: Omit<UseQueryOptions<Response>, 'queryFn' | 'queryKey'> = {},
) => {
  const { data, ...query } = useQuery({
    ...options,
    queryKey: ['bulletin_boards', SUCCESS_PAGE_BOARD_CODE],
    queryFn,
    select: selectSuccessBoards,
  });

  return { ...query, bulletinBoards: data };
};
